import { PipeTransform, Pipe } from '@angular/core';
import * as _ from 'lodash';

@Pipe({name: 'enumkeystext'})
export class EnumTextValuesPipe implements PipeTransform {

  transform(value, args: string[]): any {
    const textValues = [];
    for (const enumMember in value) {
      if (!isNaN(parseInt(enumMember, 10))) {
        // textValues.push({value: parseInt(enumMember, 10), text: _.replace(_.startCase(value[enumMember]), 'xxx', ' -')});
        textValues.push({value: _.replace(_.startCase(value[enumMember]), 'xxx', ' -'), text: _.replace(_.startCase(value[enumMember]), 'xxx', ' -')});
      }
    }
    // console.log(textValues);
    return textValues;
  }

}



// WEBPACK FOOTER //
// ./client/app/shared/pipes/enum-keys-text.pipe.ts